import {Component, Input, OnInit} from '@angular/core';
import {DialogConfig} from '../../../../shared/interfaces/dialog';
import {ChartSettingsDialogComponent} from './chart-settings-dialog/chart-settings-dialog.component';
import {AdRequestParams} from '../../../../shared/interfaces/ad-reports';
import {AppState} from '../../../../shared/store/store';
import {Store} from '@ngrx/store';
import {dialogOpen} from '../../../../shared/store/dialog/dialog.actions';

@Component({
  selector: 'app-chart-settings',
  templateUrl: './chart-settings.component.html',
  styleUrls: ['./chart-settings.component.scss']
})
export class ChartSettingsComponent implements OnInit {
  @Input() public params: Partial<AdRequestParams>;
  @Input() public disabled: boolean;

  public dialogConfig: DialogConfig = {
    data: {
      component: ChartSettingsDialogComponent
    },
    width: '600px',
    height: 'auto'
  }

  constructor(
    private readonly _store: Store<AppState>
  ) { }

  ngOnInit(): void {}

  public onOpenDialog(): void {
    this._store.dispatch(dialogOpen({
      component: ChartSettingsDialogComponent,
      config: {
        width: '600px',
        height: 'auto'
      },
      data: this.params,
    }));
  }

}
